var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-outer-wrapper" },
    [
      _c(
        "el-row",
        { staticClass: "main-content font-family" },
        [
          _c(
            "el-col",
            { staticClass: "left-content", attrs: { span: 24 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "line-height": "2"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("LIST YOUR DEVELOPMENTS ON UNIFI TODAY!")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticStyle: { "font-size": "24px", "margin-top": "20px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 2 } }, [
                    _c("i", { staticClass: "el-icon-circle-check" })
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 22 } }, [
                    _c("span", [
                      _vm._v("Present your developments to an engaged audience")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticStyle: { "font-size": "24px", "margin-top": "10px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 2 } }, [
                    _c("i", { staticClass: "el-icon-circle-check" })
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 22 } }, [
                    _c("span", [
                      _vm._v(
                        "Access our network of channel partners with exclusive clientele"
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticStyle: { "font-size": "24px", "margin-top": "10px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 2 } }, [
                    _c("i", { staticClass: "el-icon-circle-check" })
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 22 } }, [
                    _c("span", [_vm._v("Higher success, faster sales results")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticStyle: { "font-size": "24px", "margin-top": "10px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c("el-col", { attrs: { span: 2 } }, [
                    _c("i", { staticClass: "el-icon-circle-check" })
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 22 } }, [
                    _c("span", [
                      _vm._v(
                        "Support and assistance available to list your project"
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "content-wrapper", attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    padding: "10px 0 20px 0"
                                  },
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        "font-size": "18px"
                                      }
                                    },
                                    [_vm._v("Request to Join UNIFI Property")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "requestAgentForm",
                              staticStyle: {
                                "font-family": "DINosaur-a, sans-serif"
                              },
                              attrs: {
                                model: _vm.requestAgentForm,
                                rules: _vm.rules,
                                "label-position": "top",
                                "label-width": "100px"
                              },
                              nativeOn: {
                                submit: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "First Name",
                                                    prop: "firstName"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "50",
                                                      placeholder:
                                                        "Your first name"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestAgentForm
                                                          .firstName,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.requestAgentForm,
                                                          "firstName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "requestAgentForm.firstName"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Last Name",
                                                    prop: "lastName"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "100",
                                                      placeholder:
                                                        "Your last name"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestAgentForm
                                                          .lastName,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.requestAgentForm,
                                                          "lastName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "requestAgentForm.lastName"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Company",
                                                    prop: "companyName"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "100",
                                                      placeholder:
                                                        "Agency/Developer name"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestAgentForm
                                                          .companyName,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.requestAgentForm,
                                                          "companyName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "requestAgentForm.companyName"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Location",
                                                    prop: "state"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "100%"
                                                      },
                                                      attrs: {
                                                        clearable: "",
                                                        filterable: "",
                                                        placeholder:
                                                          "Select a state"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.validateField(
                                                            "state"
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.requestAgentForm
                                                            .state,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.requestAgentForm,
                                                            "state",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "requestAgentForm.state"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.STATES(),
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value
                                                          }
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Email",
                                                    prop: "email"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "100",
                                                      placeholder: "Your email"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestAgentForm
                                                          .email,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.requestAgentForm,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "requestAgentForm.email"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Phone Number",
                                                    prop: "phoneNumber"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      maxlength: "20",
                                                      placeholder:
                                                        "Your phone number"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestAgentForm
                                                          .phoneNumber,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.requestAgentForm,
                                                          "phoneNumber",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "requestAgentForm.phoneNumber"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Message",
                                                    prop: "message"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      maxlength: "1000",
                                                      "show-word-limit": "",
                                                      placeholder: "Message"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestAgentForm
                                                          .message,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.requestAgentForm,
                                                          "message",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "requestAgentForm.message"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticClass: "join-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onSubmit(
                                                            "requestAgentForm"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Contact Us\n                          "
                                                      ),
                                                      _vm.loading
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-loading"
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "margin-top": "20px"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "28px",
                            display: "flex",
                            "text-align": "center"
                          }
                        },
                        [_vm._v("Agent & Developer Login")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "margin-top": "20px"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "sign-in-btn",
                          attrs: { type: "primary", size: "large" },
                          on: { click: _vm.redirectToAgentLogin }
                        },
                        [_vm._v("\n            Login\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { padding: "10px 0 20px 0" }, attrs: { span: 24 } },
            [
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "feature-image",
                  attrs: {
                    src: require("./../../../assets/agent-section-2-page-background.png"),
                    alt: "UNIFI Property Platform Preview"
                  }
                })
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-row",
                { staticClass: "step-row" },
                [
                  _c(
                    "el-col",
                    { staticClass: "step-title", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Step 1")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "step-desc", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Create account")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "step-row" },
                [
                  _c(
                    "el-col",
                    { staticClass: "step-title", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Step 2")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "step-desc", attrs: { span: 24 } },
                    [
                      _c("span", [
                        _vm._v("Upload project information to UNIFI")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "step-row" },
                [
                  _c(
                    "el-col",
                    { staticClass: "step-title", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Step 3")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "step-desc", attrs: { span: 24 } },
                    [
                      _c("span", [
                        _vm._v(
                          "Publish the project live to our channel partners"
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "step-row" },
                [
                  _c(
                    "el-col",
                    { staticClass: "step-title", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Step 4")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "step-desc", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Receive sales for your project")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "step-row" },
                [
                  _c(
                    "el-col",
                    { staticClass: "step-title", attrs: { span: 24 } },
                    [_c("span", [_vm._v("Step 5")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "step-desc", attrs: { span: 24 } },
                    [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("Repeat!")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ec85b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ec85b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/agentRegistration/agentRegistrationSection1-Interim.vue
// module id = null
// module chunks = 